import { render, staticRenderFns } from "./RevenueManagerSetupBookingWindowTable.vue?vue&type=template&id=43946732&scoped=true&"
import script from "./RevenueManagerSetupBookingWindowTable.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupBookingWindowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43946732",
  null
  
)

export default component.exports